var map = {
	"./tyre-default.png": 154,
	"./tyre-green-1.png": 182,
	"./tyre-green-2.png": 312,
	"./tyre-green-3.png": 313,
	"./tyre-green.png": 112,
	"./tyre-high.png": 137,
	"./tyre-low.png": 180,
	"./tyre-middle.png": 153,
	"./tyre-red-1.png": 314,
	"./tyre-red-2.png": 315,
	"./tyre-red-3.png": 316,
	"./tyre-red.png": 139,
	"./tyre-yellow-1.png": 317,
	"./tyre-yellow-2.png": 318,
	"./tyre-yellow-3.png": 319,
	"./tyre-yellow.png": 181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 405;